import { defaultConfigComponent } from './Events';

import * as yup from 'yup';
import CrudPage from '@modules/cruds/CrudPage';
import EventForm from './EventForm';

//CONSTANTS
const MAX_LAT = 90;
const MIN_LAT = -90;
const MAX_LON = 180;
const MIN_LON = -180;

const eventSchema = yup.object().shape({
  name: yup.string().required().label('Name'),
  eventTypeId: yup
    .mixed()
    .test('is-string-or-object', 'EventType', value => {
      return typeof value === 'string' || typeof value === 'object';
    })
    .required()
    .label('EventType'),
  GPSCoordinates: yup
    .object()
    .shape({
      y: yup
        .number()
        .max(MAX_LAT, 'Latitude must be between -90 and 90 degrees')
        .min(MIN_LAT, 'Latitude must be between -90 and 90 degrees'),
      x: yup
        .number()
        .max(MAX_LON, 'Longitude must be between -180 and 180 degrees')
        .min(MIN_LON, 'Longitude must be between -180 and 180 degrees'),
    })
    .nullable(),
  items: yup
    .mixed()
    .test('is-string-or-object', 'Related items', value => {
      return typeof value === 'string' || typeof value === 'object';
    })
    .required()
    .label('Related items'),
});

const EventPage = props => {
  return <CrudPage key={'eventPage'} configComponent={defaultConfigComponent} form={EventForm} validationSchema={eventSchema} />;
};

export default EventPage;
